import React, { useEffect, useState } from "react";
import Billing from "../component/Billing";
import { getBillingService } from "../services/BillingService";
import { Apinames } from "../utils/Apiname";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import StripePaymentModal from "../component/StripePaymentModal";

type Props = {};

const BiilingScreen = (props: Props) => {
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [billingList, setBillingList] = useState<any[]>([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState<boolean>(false);
  const [selectedBill, setSelectedBill] = useState<any>(null);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    const currentMonth = new Date().toLocaleString("en-US", {
      month: "long",
    });
    setSelectedMonth(currentMonth);
    getBillinglist(currentMonth.toUpperCase());
  }, []);

  const getBillinglist = async (val: any) => {
    try {
      let endpoint = `${Apinames.billingGetBills}?month=${val}`;
      const response = await getBillingService(endpoint);

      if (response?.result) {
        setBillingList(response?.result);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleExportPDF = () => {
    // Hide actions column before export
    const actionHeaders = document.querySelectorAll(".no-pdf");
    actionHeaders.forEach((el) => ((el as HTMLElement).style.display = "none"));

    const input = document.getElementById("billing-table");
    if (!input) return;

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("billing-report.pdf");

      // Restore actions column
      actionHeaders.forEach((el) => ((el as HTMLElement).style.display = ""));
    });
  };

  const onPressMonth = (val: any) => {
    setSelectedMonth(val);
    getBillinglist(val.toUpperCase());
  };

  const onPayBillPressed = (billId: number) => {
    // Find the bill details from the billing list
    const bill = billingList.find((item) => item.bill.id === billId);
    if (bill) {
      setSelectedBill(bill);
      setIsPaymentModalOpen(true);
    }
  };

  const handlePaymentSuccess = () => {
    // Refresh the billing list after successful payment
    getBillinglist(selectedMonth.toUpperCase());
    setIsPaymentModalOpen(false);
    setSelectedBill(null);
  };

  const handleClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setSelectedBill(null);
  };
  return (
    <>
      <Billing
        mainLoading={mainLoading}
        billingList={billingList}
        handleExportPDF={handleExportPDF}
        selectedMonth={selectedMonth}
        months={months}
        onPressMonth={onPressMonth}
        onPayBillPressed={onPayBillPressed}
      />

      {selectedBill && (
        <StripePaymentModal
          isOpen={isPaymentModalOpen}
          onClose={handleClosePaymentModal}
          billId={selectedBill.bill.id}
          amount={selectedBill.bill.amount}
          userName={selectedBill.user.name}
          onPaymentSuccess={handlePaymentSuccess}
        />
      )}
    </>
  );
};

export default BiilingScreen;
